module.exports = __webpack_public_path__ + "static/media/language.27ce40d5.svg";